import Vue from 'vue'
import AppMain from './app.vue'

new Vue({
  render: h => h(AppMain)
}).$mount('#app')